<script lang="ts">
  export let tab: object
  export let checked: boolean
</script>

<div>
  <input type="radio" name="tab" id={tab.code} checked={checked} on:click />
  <label for={tab.code} class:active={checked}>{tab.description}</label>
</div>

<style>
  label {
    display: inline-block;
    font-size: 16px;
    line-height: 24px;
    color: #212121;
    padding: 5px 20px;
    border: none;
    outline: none;
    cursor: pointer
  }

  input {
    display: none;
  }

  input:checked~label {
    color: #fff;
    background: linear-gradient(249.76deg, #37B55E -8.32%, #7BD3FF 108.85%), #FFFFFF;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
    border-radius: 50px;
  }
</style>
